import React from "react";
import { Header, Modal, NavBar, VideoCard } from "../../components";
import { useAuth, useModal } from "../../context";
import { useDocumentTitle } from "../../customHooks";
import "../commonPage.css";
import styles from "./currentUserProfile.module.css";
import EditProfileForm from "../../components/EditProfileForm/EditProfileForm";

export const CurrentProfilePage = () => {
  useDocumentTitle("Profile");
  const { currentUser } = useAuth();
  const { isEditProfileModal, setIsEditProfileModal } = useModal();
  const { user, videosByCurrentUser } = currentUser;
  return (
    <main className="page-main">
      <Header />
      <NavBar />
      <Modal
        showModal={isEditProfileModal}
        setShowModal={setIsEditProfileModal}
      >
        <EditProfileForm />
      </Modal>
      <section className="page-content">
        <div className="profile__section">
          <div className={styles.coverimage__wrapper}>
            <img
              loading="lazy"
              className={styles.coverimage}
              src={user?.coverImage}
              alt="coverImage"
            />
          </div>
          <div className={styles.avatar__wrapper}>
            <img
              loading="lazy"
              className={styles.avater__image}
              src={user?.avatar}
              alt="avatar"
            />
          </div>
          <div className={styles.profile__details}>
            <div>
              <div className={styles.user__fullname}>{user?.fullName}</div>
              <div className={styles.user__username}>@{user?.username}</div>
            </div>
            <div className={styles.btn__wrapper}>
              <button
                onClick={() => setIsEditProfileModal((prev) => !prev)}
                type="button"
                className="btn btn-secondary border-radius-xs"
              >
                Edit Profile
              </button>
            </div>
          </div>
        </div>
        {videosByCurrentUser?.length > 0 && (
          <div className={styles.video__section}>
            {videosByCurrentUser.map((video) => (
              <VideoCard
                key={video?._id}
                video={video}
                isProfile={true}
                avatar={user?.avatar}
              />
            ))}
          </div>
        )}
      </section>
    </main>
  );
};
